export default "__VITE_PUBLIC_ASSET__88ea95a8__"